import axios from "axios";
import config from "../config";

export const baseURL = `${config.get("API_URL")}`;

export const instance = axios.create({
    baseURL,
    timeout: 100000,
});

// ✅ Function to refresh the token
const refreshAccessToken = async () => {
    try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token available");

        const response = await axios.post(`${baseURL}/user/refresh`, { token: refreshToken });
        const newAccessToken = response.data.accessToken;

        // ✅ Store new access token in local storage
        localStorage.setItem("authToken", newAccessToken);

        return newAccessToken;
    } catch (error) {
        console.error("Refresh token failed:", error);
        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login"; // Redirect to login page
        return null;
    }
};

// ✅ Axios Response Interceptor to handle token expiration
instance.interceptors.response.use(
    (response) => response, // ✅ Return response normally if no error
    async (error) => {
        const originalRequest = error.config;
        // ✅ Check if the error is due to token expiration
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            const newAccessToken = await refreshAccessToken();
            if (!newAccessToken) return Promise.reject(error);

            // ✅ Update Authorization header with new token
            originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

            return instance(originalRequest); // Retry the original request
        }

        return Promise.reject(error);
    }
);

export default instance;
